import React from 'react';
import moment from 'moment';

const monthToString = (month) => {
    const monthStrings = {
        0: 'jan',
        1: 'feb',
        2: 'mars',
        3: 'apr',
        4: 'maj',
        5: 'jun',
        6: 'jul',
        7: 'aug',
        8: 'sept',
        9: 'okt',
        10: 'nov',
        11: 'dec',
    };
    return monthStrings[month];
};

const DisplayDate = ({ value, dateFormat }) => {
    const dateTime = moment(value, dateFormat);
    const formattedDate = `${dateTime.date()} ${monthToString(dateTime.month())} ${dateTime.year()}`;

    return <div>{formattedDate}</div>;
};

export default DisplayDate;
